import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import { AlertService } from '../alert.service';
import { OrganizationSubscription } from '../organization-subscription';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { SettingService } from '../setting.service';
import { Subscription } from '../subscription';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { FormatDateTimePipe } from '@main/format-date-time.pipe';
import { CancelSubscriptionAlertModalComponent } from '@app-shared/modals/cancel-subscription-alert-modal/cancel-subscription-alert-modal.component';
import { CancelSubscription } from '@main/cancel-subscription';
import { AuthService } from '@main/auth.service';

@Component({
  selector: 'app-organization-update-subscription',
  templateUrl: './organization-update-subscription.component.html',
  styleUrls: ['./organization-update-subscription.component.css'],
  imports: [ReactiveFormsModule, NgFor, NgIf, CommonModule, FormatDateTimePipe]
})
export class OrganizationUpdateSubscriptionComponent implements OnInit {

  // Properties
  @Output() saved: EventEmitter<OrganizationSubscription> = new EventEmitter<OrganizationSubscription>();

  selectedSubscription: OrganizationSubscription;
  newSubscription: any;
  selectedPromotion: any;
  subscriptionForm!: UntypedFormGroup;
  errorMsg: string;
  subscriptions: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private settingService: SettingService,
    private alertService: AlertService,
    private modalService: NgbModal,
    public modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.subscriptionForm = new UntypedFormGroup({
      shouldRenew: new UntypedFormControl(false),
      renewalDate: new UntypedFormControl()
    });
    this.getSubscriptions();
  }

  // Get Organization Subscription
  private getOrganizationSubscription(): void {
    this.settingService.getOrganizationSubscription("STANDARD").subscribe((subscription) => {
      this.selectedSubscription = subscription;
    });
  }

  // Get Subscriptions
  private getSubscriptions(promoCode: string | null = null): void {
    if (typeof promoCode == 'string') promoCode = promoCode.toUpperCase();
    this.settingService.getSubscriptionsList().subscribe((subscriptions) => {
      if (promoCode && this.subscriptions.length > 0) {
        const subscription = subscriptions.find((sub) => { return sub.promotions.map((p) => { return p.code }).includes(promoCode) });
        if (subscription) {
          this.selectedPromotion = subscription.promotions.find((p) => {
            return p.code == promoCode && p.isActive;
          });
          this.errorMsg = null;
          if (this.selectedPromotion) {
            this.subscriptions = subscriptions.filter(subs => subs.isDefault || subs.price == subscription.price);
          } else {
            this.errorMsg = 'Invalid Promo Code';
          }
        } else {
          this.errorMsg = 'Invalid Promo Code';
        }
      } else {
        this.subscriptions = subscriptions.filter(subs => subs.isDefault);
      }
      this.subscriptions = this.subscriptions.filter(subs => subs.id !== this.selectedSubscription?.subscriptionId);
    });
  }

  // Open Cancel Subscription Modal
  openCancelSubscriptionModal() {
    const modalReference = this.modalService.open(CancelSubscriptionAlertModalComponent);
    modalReference.componentInstance.okay.subscribe((cancelEvent: CancelSubscription) => {
      this.settingService.cancelSubscription(cancelEvent).subscribe(() => {
        this.authService.logout();
      });
    })
  }

  // Cancel Organization Subscription Change
  cancelOrganizationSubscriptionChange(): void {
    this.settingService.cancelOrganizationSubscriptionChange().subscribe(() => {
      this.alertService.showSuccessAlert('Subscription Change Canceled');
      this.getOrganizationSubscription();
      this.getSubscriptions();
      this.saved.emit();
    });
  }

  // Select Subscription
  selectSubscription(subscription: Subscription) {
    this.newSubscription = subscription;
  }

  // Display Tagline
  displayTagline(subscription: any): boolean {
    const promotion = subscription.promotions.find((promo: any) => { return promo.code == this.selectedPromotion.code });
    return promotion !== undefined;
  }

  // Update Subscription
  updateSubscription(): void {
    this.settingService.updateSubscription(this.newSubscription.id).subscribe(() => {
      this.alertService.showSuccessAlert('Subscription Updated');
      this.newSubscription = null;
      this.getOrganizationSubscription();
      this.getSubscriptions();
      this.saved.emit();
    });
  }

  // get Schedule Subscription name
  getScheduleSubscriptionName(subscriptionId: string): string {
    const newSubscription = this.subscriptions.find(sub => sub.id === subscriptionId);
    return newSubscription ? newSubscription.name : 'N/A';
  }
}
